<section class="dashboard">
  <div class="dashboard-main">
    <header class="dashboard-header">
      <div>
        <h1>Help</h1>
        <p class="header-subtitle">Quick answers and workflow reminders for Do Your Shades.</p>
      </div>
    </header>

    <div class="panel-card">
      <div class="panel-header">
        <h2>Quick Start</h2>
      </div>
      <div class="panel-content">
        <ol class="steps-list">
          @for (step of quickSteps; track $index) {
            <li>{{ step }}</li>
          }
        </ol>
      </div>
    </div>

    <div class="panel-card">
      <div class="panel-header">
        <h2>Daily Checklist</h2>
      </div>
      <div class="panel-content">
        <div class="checklist">
          <label class="check-item"><input type="checkbox" /> Confirm builder/model/elevation</label>
          <label class="check-item"><input type="checkbox" /> Review rooms without blinds</label>
          <label class="check-item"><input type="checkbox" /> Verify measurement warnings</label>
          <label class="check-item"><input type="checkbox" /> Send estimate after approval</label>
        </div>
      </div>
    </div>

    <div class="panel-card">
      <div class="panel-header">
        <h2>Contacts</h2>
      </div>
      <div class="panel-content">
        <div class="contact-grid">
          @for (contact of contacts; track contact.label) {
            <div class="contact-card">
              <div class="contact-label">{{ contact.label }}</div>
              <div class="contact-value">{{ contact.value }}</div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>
